import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  type FormInstance,
  Popconfirm,
  Row,
  Select,
  Table,
} from "antd";
import { type ColumnsType } from "antd/lib/table";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import {
  addZone,
  deleteNthZone,
  selectManageZones,
  selectAvailableZones,
  changeNthZone,
} from "../../../redux/slices/manageUsers/manageUsersSlice";
import {
  type NetworkType,
  type ZoneCfg,
  type ZoneType,
  ZoneTypes,
} from "../../../redux/slices/manageUsers/manageUsersTypes";
import "./ZoneTable.css";
import { AutoCompleteClient } from "../../../components/AutoCompleteClient";
const { Option } = Select;

// type ColumnTypes = Exclude<EditableTableProps['columns'], undefined>;

interface ZoneTableProps {
  form: FormInstance;
}

export const ZoneTable: React.FC<ZoneTableProps> = ({
  form,
}: ZoneTableProps) => {
  const zones: ZoneType[] = useAppSelector(selectManageZones);
  const availableZones = useAppSelector(selectAvailableZones);
  const dispatch = useAppDispatch();

  const handleAdd = (): void => {
    const newZone: ZoneType = {
      domain: "",
    };
    dispatch(addZone(newZone));
  };

  const handleDelete = (id: number): void => {
    dispatch(deleteNthZone(id));
  };

  const onValueChanged = (
    index: number,
    key: keyof ZoneType,
    value: string | ZoneTypes | NetworkType,
  ): void => {
    console.log("onValueChanged", index, key, value);
    dispatch(changeNthZone({ index, key, value }));
  };

  const getDomains = (): string[] => {
    const domains = [];
    for (const key in availableZones) {
      domains.push(key);
    }
    return domains;
  };

  const getAvailableTypes = (zoneCfg: ZoneCfg): JSX.Element => {
    if (zoneCfg == null) return <></>;
    if (zoneCfg.all)
      return (
        <>
          <Option key="all" value={ZoneTypes.all}>
            all
          </Option>
          <Option key="network" value={ZoneTypes.network}>
            network
          </Option>
          <Option key="addresses" value={ZoneTypes.addresses}>
            addresses
          </Option>
        </>
      );
    const options = [];
    if (zoneCfg?.networks != null)
      options.push(
        <Option key="network" value={ZoneTypes.network}>
          network
        </Option>,
      );
    if (zoneCfg.addresses)
      options.push(
        <Option key="addresses" value={ZoneTypes.addresses}>
          addresses
        </Option>,
      );
    return <>{options}</>;
  };

  const defaultColumns: ColumnsType<ZoneType> = [
    {
      title: "Домен",
      dataIndex: "domen",
      // editable: true,
      render: (_: any, record: ZoneType, index) => {
        console.log("column render", record);
        return (
          <Select
            style={{ width: "100%" }}
            value={record.domain}
            onSelect={(val) => {
              onValueChanged(index, "domain", val);
            }}
          >
            {getDomains().map((domain) => (
              <Option key={domain} value={domain}>
                {domain}
              </Option>
            ))}
          </Select>
        );
      },
      width: "30%",
    },
    {
      width: "30%",
      title: "Тип зоны",
      dataIndex: "zoneType",
      render: (_: any, record: ZoneType, index) => {
        return (
          <Select
            value={record.type}
            style={{ width: "100%" }}
            onSelect={(val: ZoneTypes) => {
              onValueChanged(index, "type", val);
            }}
          >
            {getAvailableTypes(availableZones[record.domain])}
          </Select>
        );
      },
    },
    {
      width: "30%",
      title: "Зона",
      dataIndex: "zone",
      render: (_: any, record: ZoneType, index) => {
        switch (record.type) {
          case ZoneTypes.all:
            return "-";
          case ZoneTypes.network:
            return (
              <AutoCompleteClient
                initValue={record.zone}
                domain={record.domain}
                onChange={(val: NetworkType) => {
                  onValueChanged(index, "zone", val);
                }}
              />
            );
          default:
            break;
        }
        return "-";
      },
    },
    {
      dataIndex: "operation",
      render: (_: any, record: ZoneType, index) => (
        // zones.length >= 1 ? (
        <Popconfirm
          okText={"Да"}
          cancelText={"Отменить"}
          title="Удалить зону?"
          onConfirm={() => {
            handleDelete(index);
          }}
        >
          <DeleteOutlined style={{ color: "#f5222d" }} />
        </Popconfirm>
      ),
      // ) : null,
    },
  ];

  return (
    <div>
      <Row>
        <Col flex="auto"></Col>
        <Col span={6} offset={1} flex="none">
          <Button
            onClick={handleAdd}
            type="primary"
            icon={<PlusOutlined />}
            style={{ marginBottom: 16 }}
          >
            Добавить зону
          </Button>
        </Col>
      </Row>

      <Table
        // components={components}
        // rowClassName={() => 'editable-row'}
        bordered
        dataSource={zones}
        columns={defaultColumns}
      />
    </div>
  );
};
